export const DEFAULT_SOLUTION_KEY = "tootable";
const ACTIVE_SOLUTION_STORAGE_KEY = "activeSolutionKey";

export const SOLUTIONS = [
  {
    key: "tootable",
    name: "TooTable",
    parentBrand: "Toofacyl",
    tagline: "Mesas, ordenes y experiencias",
    businessLabel: "Restaurante",
    businessPluralLabel: "Restaurantes",
    productLabel: "Platillo",
    productPluralLabel: "Platillos",
    color: "#10989a",
    icon: "bx-table",
  },
  {
    key: "tooretail",
    name: "TooRetail",
    parentBrand: "Toofacyl",
    tagline: "Productos, inventario y ventas",
    businessLabel: "Tienda",
    businessPluralLabel: "Tiendas",
    productLabel: "Producto",
    productPluralLabel: "Productos",
    color: "#128f91",
    icon: "bx-store",
  },
];

export function solutionForKey(key) {
  return SOLUTIONS.find((solution) => solution.key === key) || SOLUTIONS[0];
}

export function userSolutionKeys(user) {
  const keys = user && Array.isArray(user.solutionKeys) ? user.solutionKeys : [];
  const role = String((user && user.rol) || "").toUpperCase();

  if (!keys.length && ["ADMIN", "SUPERADMIN"].includes(role)) {
    return SOLUTIONS.map((solution) => solution.key);
  }

  return keys.length ? keys : [DEFAULT_SOLUTION_KEY];
}

export function userCanUseSolution(user, solutionKey) {
  return userSolutionKeys(user).includes(solutionKey);
}

export function availableSolutionsForUser(user) {
  const keys = userSolutionKeys(user);
  return SOLUTIONS.filter((solution) => keys.includes(solution.key));
}

export function activeSolutionKeyForUser(user) {
  const allowedKeys = userSolutionKeys(user);
  const storedKey = localStorage.getItem(ACTIVE_SOLUTION_STORAGE_KEY);
  const knownStoredKey = SOLUTIONS.some((solution) => solution.key === storedKey);

  if (knownStoredKey && (!user || !user.rol)) {
    return storedKey;
  }

  if (storedKey && allowedKeys.includes(storedKey)) {
    return storedKey;
  }

  const userActiveKey = user && user.activeSolutionKey;

  if (userActiveKey && allowedKeys.includes(userActiveKey)) {
    return userActiveKey;
  }

  return allowedKeys[0] || DEFAULT_SOLUTION_KEY;
}

export function activeSolutionForUser(user) {
  return solutionForKey(activeSolutionKeyForUser(user));
}

export function setActiveSolutionKey(solutionKey) {
  localStorage.setItem(ACTIVE_SOLUTION_STORAGE_KEY, solutionKey);
  window.dispatchEvent(new CustomEvent("toofacyl:solution-changed", { detail: { solutionKey } }));
}
